/**
 * Storage Errors definition
 *
 * @enum {number}
 */
export enum StorageErrors {
  ItemNotFound = 'item not found'
}
